import { AppThunk } from '../../../../store/reducers';
import { GET, POST, PUT, DELETE } from '../../../../service/HttpMethod';
import { beforeSend } from '../../../../components/Toast/Store';
import { InitialState, List, Details, ActionConstant, ActionType } from './types';
import { toastFunction } from '../../../../helpers/toastShow';

const details = {
	id: 0,
	tradeId: 0,
	divisionNumber: '',
	keywordHeading: '',
	grouping: '',
	promptText: '',
	promptType: '',
};

const initialState: InitialState = {
	initialList: true,
	fetching: true,
	detailsFetching: true,
	specSummaryPromptList: [],
	scopePromptList: [],
	total: 0,
	details,
	keywords: '',
	statusCode: 0,
	noOfResults: 0,
	totalResults: 0,
};

const GetListAction = (data: List): ActionType => ({
	type: ActionConstant.GET_LIST,
	data,
});

const GetDetailsAction = (data: Details): ActionType => ({
	type: ActionConstant.GET_DETAILS,
	data,
});

export const getList = (tradeId = 0): AppThunk => {
	const getConfig = { url: `/trade/${tradeId}/aiPrompts` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetListAction(data.data));
		} catch (error) {
			// dispatch(GetListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getDetails = (id = 0, tradeId = 0): AppThunk => {
	const getConfig = { url: `trade/${tradeId}/aiPrompts/${id}` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetDetailsAction(data.data));
		} catch (error) {
			dispatch(GetDetailsAction(details));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export function create(datas = {}, id = 0): AppThunk {
	const postConfig = {
		data: datas,
		url: `trade/${id}/aiPrompts`,
	};
	return async (dispatch) => {
		try {
			dispatch(beforeSend());
			const { status = 0 } = await POST(postConfig);
			dispatch(toastFunction('Success', 'Prompt created successfully', ''));
			dispatch(getList(id));
			dispatch({ type: ActionConstant.GET_STATUS, status });
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Prompt creation failed', ''));
		}
	};
}

export function updateAction(datas = {}, tradeId = 0, id = 0): AppThunk {
	const postConfig = {
		data: datas,
		url: `trade/${tradeId}/aiPrompts/${id}`,
	};
	return async (dispatch) => {
		try {
			dispatch(beforeSend());
			const { status = 0 } = await PUT(postConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(toastFunction('Success', 'Prompt updated successfully', ''));
			dispatch(getList(tradeId));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Prompt updation failed', ''));
		}
	};
}

export function deleteAction(tradeId = 0, id = 0): AppThunk {
	const delConfig = { url: `/trade/${tradeId}/aiPrompts/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await DELETE(delConfig);
			dispatch(toastFunction('Success', 'Prompt deleted successfully', ''));
			dispatch(getList(tradeId));
			dispatch({ type: ActionConstant.GET_STATUS, status });
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Prompt deletion failed', ''));
		}
	};
}

export const clearDetails = (): ActionType => ({ type: ActionConstant.CLEAR_DETAILS });
export const clearStatus = (): ActionType => ({ type: ActionConstant.CLEAR_STATUS });
export const clearList = (): ActionType => ({ type: ActionConstant.CLEAR_LIST });

function promptsReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_LIST: {
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				specSummaryPromptList: rows.filter((item: Details) => item.promptType === 'SS'),
				scopePromptList: rows.filter((item: Details) => item.promptType === 'S'),
				total: count,
				fetching: false,
			};
		}
		case ActionConstant.GET_DETAILS: {
			const { data } = action;
			return {
				...state,
				details: data,
				detailsFetching: false,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}
		case ActionConstant.CLEAR_LIST: {
			return {
				...state,
				specSummaryPromptList: [],
				scopePromptList: [],
				total: 0,
				fetching: true,
			};
		}
		case ActionConstant.CLEAR_DETAILS: {
			return {
				...state,
				details,
				detailsFetching: true,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}
		default:
			return state;
	}
}

export default promptsReducer;
